export interface MontaType {
  id: string
  value: string
}

interface MontaTypeProps {
  [key: string]: MontaType
}

export const montaTypes: MontaTypeProps = {
  monta: {
    id: 'monta',
    value: 'Monta'
  },
  montaControlada: {
    id: 'montaControlada',
    value: 'Monta Controlada'
  },
  inseminacaoArtificial: {
    id: 'inseminacaoArtificial',
    value: 'Inseminação Artificial'
  }
}

export const montaTypeOptions = Object.keys(montaTypes).map((key: string) => montaTypes[key])
